import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { CUIHStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import LoginButton from './LoginButton';
import SignupButton from './SignupButton';

const LoginSignupButtons = (_ref) => {
  let {
    trackingUrl,
    trackingIdentifier
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["trackingUrl", "trackingIdentifier"]);

  return /*#__PURE__*/_jsxs(CUIHStack, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(SignupButton, {
      variant: "primary",
      trackingUrl: trackingUrl,
      trackingIdentifier: trackingIdentifier
    }), /*#__PURE__*/_jsx(LoginButton, {
      trackingIdentifier: trackingIdentifier
    })]
  }));
};

export default LoginSignupButtons;